import { ArrMessage } from "../common/ArrMessage";
export const ProwlarrMessage = ArrMessage;
